import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PostRequestPreRegister} from 'domain/usecases/others/facial-biometric';
import {RemoteFacialBiometricPostPreRegister} from 'data/usecases/others/facial-biometric/request';
import {FacialBiometricEndpoints} from 'main/factories/usecases/endpoints';

export const makePostRequestFacialBiometricPreRegister = (): PostRequestPreRegister =>
	new RemoteFacialBiometricPostPreRegister(
		makeBFFApiUrl(FacialBiometricEndpoints.preRegister),
		makeAuthorizeHttpClientDecorator(),
	);
